export const T = {
  en_GB: {
    ownership: "Ownership",
    roles: "Roles",
    flags: "Flags",
    noNegativeFlags: "No negative flags",
    activeNegativeFlag: "active negative flag",
    activeNegativeFlags: "active negative flags",
    noData: "No data available",
    noFlags: "No flags on record",
    rerunLookup: "Re-run lookup",
    screeningTitle: "PEP & sanctions screening",
    screeningHint:
      "Screens the people behind the company — beneficial owners (senior roles when none are registered) and the registered representative — against PEP and sanctions lists.",
    screenAll: "Screen persons",
    rescreen: "Re-screen",
    kindUbo: "UBO",
    kindRole: "Role",
    kindRepresentative: "Representative",
    pepHit: "PEP",
    sanctionHit: "Sanctioned",
    noHits: "No hits",
    screenedTestMode: "Test mode",
    lookup: "Lookup",
    employees: "Employees",
    founded: "Founded",
    inactive: "Inactive",
  },
  nb_NO: {
    ownership: "Eierskap",
    roles: "Roller",
    flags: "Flagg",
    noNegativeFlags: "Ingen negative flagg",
    activeNegativeFlag: "aktivt negativt flagg",
    activeNegativeFlags: "aktive negative flagg",
    noData: "Ingen data tilgjengelig",
    noFlags: "Ingen flagg registrert",
    rerunLookup: "Kjør oppslag på nytt",
    screeningTitle: "PEP- og sanksjonsscreening",
    screeningHint:
      "Sjekker personene bak selskapet — reelle rettighetshavere (ledende roller når ingen er registrert) og den registrerte representanten — mot PEP- og sanksjonslister.",
    screenAll: "Sjekk personer",
    rescreen: "Sjekk på nytt",
    kindUbo: "Reell rettighetshaver",
    kindRole: "Rolle",
    kindRepresentative: "Representant",
    pepHit: "PEP",
    sanctionHit: "Sanksjonert",
    noHits: "Ingen treff",
    screenedTestMode: "Testmodus",
    lookup: "Oppslag",
    employees: "Ansatte",
    founded: "Stiftet",
    inactive: "Inaktiv",
  },
} as const;
